const STORAGE_KEY = 'use24HourTime'
export const TIME_FORMAT_PREFERENCE_EVENT = 'timeFormatPreferenceChange'

function read(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true'
  } catch (e) {
    console.error('[timeFormatPreferenceStorage] Failed to read', e)
    return false
  }
}

function write(use24Hour: boolean): void {
  try {
    localStorage.setItem(STORAGE_KEY, String(use24Hour))
    window.dispatchEvent(new Event(TIME_FORMAT_PREFERENCE_EVENT))
  } catch (e) {
    console.error('[timeFormatPreferenceStorage] Failed to write', e)
  }
}

export const timeFormatPreferenceStorage = { get: read, set: write }
